import { useReducer, createContext, useContext } from 'react';
import { useUser } from 'context/UserContext';

const AgentDashBoardContext = createContext();
export function useAgentDashBoardContext() {
  return useContext(AgentDashBoardContext);
}
export function AgentDashBoardProvider({ children }) {
  const user = useUser();
  const dashboardReducer = (state, action) => {
    switch (action.type) {
      case 'SET_SELECTED_PRODUCER':
        return {
          ...state,
          selectedProducer: action.payload,
        };
      case 'CLEAR_SELECTED_PRODUCER':
        return {
          selectedProducer: '',
        };
      case 'SET_BASE_PRODUCER': //Producer ID set by home office  users to mimic producer
        return {
          ...state,
          baseProducer: action.payload,
        };
      case 'SET_OVERRIDE_PRODUCER':
        return {
          ...state,
          overrideProducer: action.payload,
        };
      case 'SET_CONTRACT_STATUS':
        return {
          ...state,
          contractStatus: action.payload,
        };
      default:
        throw new Error();
    }
  };
  const initialState = {
    selectedProducer: user.isHO ? '' : user.producerID.split(',')[0], //Producer ID used to generate report
    baseProducer: user.isHO ? '' : user.producerID.split(',')[0], //Producer ID used to populate producer downstream
    overrideProducer: '', //Home Office override
    contractStatus: '1', //Stores contract status value to filter producer filter
  };
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  return (
    <AgentDashBoardContext.Provider value={[state, dispatch]}>
      {children}
    </AgentDashBoardContext.Provider>
  );
}
